
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ads",
      function () {
        return require("private-next-pages/ads/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ads"])
      });
    }
  